<div>
  <iframe
    id="phone"
    allow="camera *; microphone *; autoplay *"
    [src]="urlSafety"
    [height]="appHeight"
    [width]="appWidth"
  ></iframe>
</div>
